import { render, staticRenderFns } from "./Earth.vue?vue&type=template&id=99ace4aa&scoped=true"
import script from "./Earth.vue?vue&type=script&lang=js"
export * from "./Earth.vue?vue&type=script&lang=js"
import style0 from "./Earth.vue?vue&type=style&index=0&id=99ace4aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ace4aa",
  null
  
)

export default component.exports